import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import React, {useCallback, useState} from 'react';

import {DropdownInputType} from '../../../../components/Common/FieldSearch/types/DropdownProps';
import {useSearch} from '../../../../hooks/dropdown/useSearch';
import {Column} from '../../../../stores/Form/Column';
import {isActiveFilter} from '../../utils/filters';
import {FilterDropDown} from '../FilterDropdown';

type Props = {
    componentClasses?: string;
    getCellWrap: () => HTMLDivElement | null;
    column: Column;
    zIndex?: number;
    icon?: PriorityIcon;
    dropdownInputType?: DropdownInputType;
    disabled?: boolean;
};

export const HeaderCellFilter = ({
    componentClasses,
    getCellWrap,
    column,
    zIndex,
    disabled
}: Props) => {
    const [isOpen, setOpen] = useState(false);
    const [dropdownStyles, setDropdownStyles] = useState({});
    const [, searchHandlers] = useSearch(column);
    const {handleSearchOpen, handleNavigationKeys} = searchHandlers;

    const isActive = isActiveFilter(column);

    const closeSearchDropdown = useCallback(
        e => {
            e?.stopPropagation();
            setDropdownStyles({});
            setOpen(false);
        },
        [setOpen, setDropdownStyles]
    );

    const openSearchDropdown = useCallback(
        async (e: KeyboardEvent) => {
            e.stopPropagation();
            const anchorEl = getCellWrap();
            if (anchorEl) {
                const elementRect = anchorEl.getBoundingClientRect();
                await handleSearchOpen('', false, false, state => {
                    setDropdownStyles({
                        position: 'fixed',
                        zIndex: zIndex || 10001,
                        left: elementRect.left,
                        right: 'auto',
                        width: elementRect.width,
                        top: elementRect.top
                    });
                    setOpen(true);
                });
            }
        },
        [zIndex, getCellWrap, setOpen, setDropdownStyles, handleSearchOpen]
    );
    const clickOutside = useCallback(() => setOpen(false), []);
    return (
        <>
            <Icon
                disabled={disabled}
                componentClasses={componentClasses}
                iconColor={isActive ? 'primary-500' : 'secondary-300'}
                icon={PriorityIcon.filterFill}
                onClick={openSearchDropdown}
            />
            <FilterDropDown
                onClickOutside={clickOutside}
                handleNavigationKeys={handleNavigationKeys}
                getCellWrap={getCellWrap}
                isOpen={isOpen}
                onClose={closeSearchDropdown}
                column={column.parentForm.getColumnByID(column.id)}
                dropdownStyle={dropdownStyles}
            />
        </>
    );
};
